<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p16"><span><a id="page_12"></a><a href="#/Contents#rp16">MEDITERRANEAN STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>A lovely stock scented with orange, fennel, and saffron.</i></span></p>
<p class="make"><span>Makes about 2 quarts</span></p>
<p class="hang"><span>1 each: thickly sliced large onion, leek (white part only), carrot, sweet potato, zucchini, rib celery</span></p>
<p class="hang"><span>½ each: sliced small fennel bulb, red bell pepper</span></p>
<p class="hang"><span>2 teaspoons olive oil</span></p>
<p class="hang"><span>8 cups water</span></p>
<p class="hang"><span>Juice of 1 orange</span></p>
<p class="hang"><span>1 cup dry white wine or water</span></p>
<p class="hang"><span>2 medium tomatoes, quartered</span></p>
<p class="hang"><span>1 medium bulb garlic, cut crosswise in half</span></p>
<p class="hang"><span>3 cups coarsely chopped spinach or romaine lettuce</span></p>
<p class="hang"><span>6 sprigs parsley</span></p>
<p class="hang"><span>1 each: strip orange zest (3 x 1-inch), bay leaf</span></p>
<p class="hang"><span>1–2 teaspoons bouquet garni</span></p>
<p class="hang"><span>1 teaspoon black peppercorns</span></p>
<p class="hang"><span>4 whole allspice</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Sauté onion, leek, carrot, sweet potato, zucchini, celery, fennel, and bell pepper in oil in Dutch oven 8 to 10 minutes; add remaining ingredients, except salt and pepper, and heat to boiling. Reduce heat and simmer, covered, 1½ to 2 hours. Strain, discarding vegetables and seasonings; season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 43</span></p>
<p class="per1"><span>% calories from fat: 24</span></p>
<p class="per1"><span>Protein (g): 0.5</span></p>
<p class="per1"><span>Carbohydrate (g): 3.3</span></p>
<p class="per1"><span>Fat (g): 1.2</span></p>
<p class="per1"><span>Saturated fat (g): 0.2</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 15</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.5</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0116.vue?79edf64a